import { render, staticRenderFns } from "./PartnerWithdrawalComplete.vue?vue&type=template&id=a1462ce4&scoped=true&"
import script from "./PartnerWithdrawalComplete.vue?vue&type=script&lang=js&"
export * from "./PartnerWithdrawalComplete.vue?vue&type=script&lang=js&"
import style0 from "./PartnerWithdrawalComplete.vue?vue&type=style&index=0&id=a1462ce4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1462ce4",
  null
  
)

export default component.exports